import DOMPurify from "dompurify";

export const formatDate = (dateString) => {
  if (!dateString) return "Present";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
  });
};

export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return "";
  if (imageUrl.startsWith("http")) return imageUrl;
  return `${process.env.REACT_APP_BASE_API_URL}${imageUrl}`;
};

export const sanitizeHTML = (html) => {
  if (!html) return "";
  return DOMPurify.sanitize(html);
};

export const processHTML = (html) => {
  if (!html) return "";
  const processed = html.replace(
    /<a /g,
    '<a class="paper-link" target="_blank" rel="noopener noreferrer" ',
  );
  return DOMPurify.sanitize(processed, { ADD_ATTR: ["target", "rel"] });
};
